<mat-card class="decoration-card">
    <mat-card-content>

        <mat-toolbar *ngIf="!isReadonly">
            <span class="example-spacer"></span>

            <button mat-icon-button matTooltip="add an FMEA" (click)="create()" *ngIf="!isReadonly">
                <mat-icon>plus_one</mat-icon>
            </button>
        </mat-toolbar>

        <table mat-table [dataSource]="dataSource" class="mat-elevation-z8">
            <!--- Note that these columns can be defined in any order.
              The actual rendered columns are set as a property on the row definition" -->

            <ng-container matColumnDef="fmea_report">
                <th mat-header-cell *matHeaderCellDef> FMEA Report </th>
                <td mat-cell *matCellDef="let element"> {{element.fmea_report}} </td>
            </ng-container>

            <ng-container matColumnDef="last_date">
                <th mat-header-cell *matHeaderCellDef> Last Date </th>
                <td mat-cell *matCellDef="let element"> {{element.last_date}} </td>
            </ng-container>

            <ng-container matColumnDef="fmea_findings_closed_text">
                <th mat-header-cell *matHeaderCellDef> FMEA Findings Closed? </th>
                <td mat-cell *matCellDef="let element"> {{element.fmea_findings_closed_text}} </td>
            </ng-container>

            <ng-container matColumnDef="last_dp_anual_trails_date">
                <th mat-header-cell *matHeaderCellDef> Last DP Trail </th>
                <td mat-cell *matCellDef="let element"> {{element.last_dp_anual_trails_date}} </td>
            </ng-container>

            <ng-container matColumnDef="trail_findings_closed_text">
                <th mat-header-cell *matHeaderCellDef> Trail Findings Closed? </th>
                <td mat-cell *matCellDef="let element"> {{element.trail_findings_closed_text}} </td>
            </ng-container>

            <ng-container matColumnDef="remark">
                <th mat-header-cell *matHeaderCellDef> Remark </th>
                <td mat-cell *matCellDef="let element"> {{element.remark}} </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row (click)="selectTrailDocumentFmea(row)" *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>

    </mat-card-content>
</mat-card>


